module.exports = __webpack_public_path__ + "assets/shake-logo.0bcd77ec.svg";